import React, { useState } from "react";
import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers, BridgeClientShareTypes } from "@/interfaces/enums";
import { useTranslation } from "next-i18next";

import useWxShare from "@/hooks/useWxShare";
import HeadMetaContainer from "@/containers/common/HeadMetaContainer";
import OptionDocContainer from "@/containers/docs/OptionDocContainer";
import MarkdownContent from "@/containers/docs/MarkdownContent";
import { isWeixin } from "@/utils/parserDevice";
import WeChatMask from "@/containers/common/WeChatMask";

interface Props {
	children: string;
	title?: string;
	shareTitle?: string;
	banner?: string;
	description?: string;
	className?: string;
	hiddenFooterBtn?: boolean;
	hiddenHeader?: boolean;
	onFooterBtnClick?: () => void;
	contentClick?: (url: string) => void;
}

export default function OptionView(props: Props) {
	const { t } = useTranslation("docs");
	const [wxVisible, setWxvisible] = useState(false);

	useWxShare(undefined, undefined, {
		title: props.shareTitle || props.title || "",
		desc: props.description || "",
		imgUrl: props.banner || "",
	});

	const handleBtnClick = () => {
		if (isWeixin()) {
			setWxvisible(true);
			return;
		}
		props.onFooterBtnClick?.();
	};

	const handleShare = () => {
		bridge.call(BridgeCallHandlers.ON_SHARE_BUTTON_CLICK, {
			shareTitle: (props.shareTitle || props.title || "") + "\n" + getCurrentPageLinkUrl(),
			shareUrl: getCurrentPageLinkUrl(),
			shareType: BridgeClientShareTypes.TEXT,
			shareCode: "",
			shareImgUrl: "",
			shareScene: "",
			showCopyButton: 0,
		});
	};

	const getCurrentPageLinkUrl = () => {
		if (typeof window === "undefined") {
			return "";
		}
		return window.location.href;
	};

	return (
		<HeadMetaContainer title={props.shareTitle || props.title} description={props.description} imageUrl={props.banner}>
			<OptionDocContainer
				title={props.title || ""}
				bgUrl={props.banner || ""}
				onShare={handleShare}
				footerBtnText={t("try-it-now")}
				onFooterBtnClick={handleBtnClick}
				hiddenFooterBtn={props.hiddenFooterBtn}
				hiddenHeader={props.hiddenHeader}
			>
				<MarkdownContent className={props.className} contentClick={props.contentClick}>
					{props.children}
				</MarkdownContent>
				<WeChatMask visible={wxVisible} onClose={() => setWxvisible(false)} />
			</OptionDocContainer>
		</HeadMetaContainer>
	);
}
